export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';
export const METAMASK = 'METAMASK';
export const BLOCKCHAINCONTRACT = 'BLOCKCHAINCONTRACT';